export default [{
	name: `Good verses to memorize`,
	key: `1C6EBjsS-FY6KPzKnHCVFEcpYy_Gh_bvAJWcma50Qwrw`,
}, {
	name: `Bible Acrostic`,
	key: `1OX4eS10MxNQbgfMzIZx2IEeivq6dGOc_F8X3IraMNds`,
	moreInfoUrl: `https://gist.github.com/TehShrike/54495891029b617dff4c31fb8f08251c`,
}]
